import type { ErrorReporter, UserError } from '@core/types/error'

export default defineNuxtPlugin({
  name: 'error-reporter',
  setup() {
    const errors = useState<UserError[]>('reporter.errors')
    const reporter: ErrorReporter = {
      errors: errors.value,
      error: () => {
        /* Skipping client side errors */
      },
    }
    return { provide: { reporter } }
  },
})
